var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionCloseRounded({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2929 6.29289C16.6834 5.90237 17.3164 5.90237 17.707 6.29289C18.0975 6.68342 18.0975 7.31643 17.707 7.70696L13.414 11.9999L17.707 16.2929C18.0975 16.6834 18.0975 17.3164 17.707 17.707C17.3164 18.0975 16.6834 18.0975 16.2929 17.707L11.9999 13.414L7.70696 17.707C7.31643 18.0975 6.68342 18.0975 6.29289 17.707C5.90237 17.3164 5.90237 16.6834 6.29289 16.2929L10.5859 11.9999L6.29289 7.70696C5.90237 7.31643 5.90237 6.68342 6.29289 6.29289C6.68342 5.90237 7.31643 5.90237 7.70696 6.29289L11.9999 10.5859L16.2929 6.29289Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionCloseRounded);
export default __webpack_public_path__ + "static/media/ic_action_close_rounded.e16f8c33074b525c2302015a15fe17b3.svg";
export { ForwardRef as ReactComponent };